// src/pages/vendas/NaturezaCad.js
import React, { useState, useEffect } from 'react';

import { useNatureza } from '../../contexts/vendas/NaturezaContext';
import { useMessage } from '../../contexts/geral/MessageContext';
import { useYesNo } from '../../contexts/geral/YesNoContext';
import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';
import Input from '../../components/input/Input';
import Select from '../../components/input/Select';
import InputCheck from '../../components/input/InputCheck';
import ModalFooter from '../../components/modalForm/ModalFooter';
import { Natureza } from '../../models/vendas/Natureza';
import ModalActions, { ModalActionButton } from '../../components/modalForm/ModalActions';

const NaturezaCad = ({ show, onHide }) => {
    const { naturezas, addNatureza, updateNatureza, deleteNatureza, handleShowNaturezaSearch } = useNatureza();
    const [natureza, setNatureza] = useState(new Natureza());    
    const { showMessage } = useMessage();
    const { showYesNo } = useYesNo();
    const [novoReg, setNovoReg] = useState(false);

    useEffect(() => {
        if (show) handleNovo();
    }, [show]);

    const handleNovo = () => {
        setNatureza(new Natureza());
        setNovoReg(true);
    };

    const handleEditar = (id) => {
        if (id === 0) {
            showMessage("Selecione uma Natureza para editar!");
            return;
        }
        setNovoReg(false);
    };

    const handleDelete = async () => {
        if (!natureza?.id) {
            showMessage("Selecione uma Natureza para excluir!");
        } else {
            const confirm = await showYesNo("Deseja excluir a natureza selecionada?");
            if (confirm) {
                await deleteNatureza(natureza.id);
                handleNovo();
            }
        }
    };

    const handleSave = async () => {
        if (!natureza.descricao) {
            showMessage("Informe a descrição da natureza!");
            return;
        }

        if (!natureza.id) {
            await addNatureza(natureza);
        } else {
            await updateNatureza(natureza);
        }
        handleNovo();
    };

    const handleExit = () => {
        const naturezaSel = naturezas.find(n => n.id === natureza.id);
        if (naturezaSel) {
            setNatureza(naturezaSel);
            handleEditar(natureza.id);
        } else {
            setNatureza(new Natureza());
        }
    };

    const handleSelectNatureza = async () => {
        const naturezaSel = await handleShowNaturezaSearch();

        if (naturezaSel) {
            setNatureza(naturezaSel);
            handleEditar(naturezaSel.id);
        } else {
            handleNovo();
        }
    };

    if (!show) return null;

    return (
        <ModalContainer show={show} variant="cadastro" onHide={onHide}>
            <ModalHeader title={novoReg ? 'Nova Natureza' : 'Alterar Natureza'} onHide={onHide} />
            <ModalBody>
                <form>
                    <div className="input-group mb-3">
                        <Input
                            label="Código"
                            value={natureza.id || ''}
                            onChange={(e) => setNatureza({ ...natureza, id: parseInt(e.target.value) || 0 })}
                            onBlur={handleExit}
                            disabled={!novoReg}
                            btnBuscar={handleSelectNatureza}
                        />
                        <Input
                            label="Descrição"
                            value={natureza.descricao}
                            onChange={(e) => setNatureza({ ...natureza, descricao: e.target.value })}
                            size={300}
                            autoFocus
                        />
                        <Select
                            label="Tipo Movimento"
                            value={natureza.tipoMov}
                            onChange={(e) => setNatureza({ ...natureza, tipoMov: parseInt(e.target.value) })}
                            size={150}
                            options={[
                                { value: 0, label: 'Sem Movimento' },
                                { value: 1, label: 'Entrada' },
                                { value: 2, label: 'Saída' },
                            ]}
                        />
                        <InputCheck
                            label="Movimenta Estoque"
                            checked={natureza.movEstoque}
                            onChange={(e) => setNatureza({ ...natureza, movEstoque: e.target.checked })}
                        />
                        <Input
                            label="CFOP"
                            value={natureza.cfopCod || ''}
                            onChange={(e) => setNatureza({ ...natureza, cfopCod: e.target.value })}
                        />
                        <InputCheck
                            label="Usar CFOP nos Itens"
                            checked={natureza.usaCFOPItens}
                            onChange={(e) => setNatureza({ ...natureza, usaCFOPItens: e.target.checked })}
                        />
                        <Input
                            label="Informações complementares"
                            value={natureza.infCpl || ''}
                            onChange={(e) => setNatureza({ ...natureza, infCpl: e.target.value })}
                            size={430}
                            rows={2}
                        />
                        <Input
                            label="Informações do Fisco"
                            value={natureza.infAdFisco || ''}
                            onChange={(e) => setNatureza({ ...natureza, infAdFisco: e.target.value })}
                            size={430}
                            rows={2}
                        />
                    </div>
                </form>
            </ModalBody>
            <ModalFooter>
                <ModalActions >
                    <ModalActionButton type='button' className="btn btn-primary" onClick={handleSave} action="save">
                        Salvar
                    </ModalActionButton>
                    <ModalActionButton type='button' className="btn btn-danger" onClick={handleDelete} disabled={novoReg} action="delete">
                        Excluir
                    </ModalActionButton>
                    <ModalActionButton type='button' className="btn btn-secondary" onClick={handleNovo} disabled={novoReg} action="new">
                        Novo
                    </ModalActionButton>
                </ModalActions>
            </ModalFooter>
        </ModalContainer>
    );
};

export default NaturezaCad;
